var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('PageTitle',{attrs:{"title":"Starfsmenn"}}),_c('StaffSearch',{attrs:{"slidebar":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }